const Input = ({
	id,
	FirstIcon, // Can be a component or `false`
	placeholder,
	value,
	onChange,
	onClear,
	label,
	info,
	className = "",
	isDisabled = false,
	maxLength = 255,
	type = "text",
	infoColor = "text-gray-400",
	max = "",
	min = "",
	autoComplete = "off",
}) => {
	const iconbaseClasses = "w-4 h-4 lg:w-5 lg:w-5  text-gray-400 dark:text-white";

	// Determine whether to apply padding based on the presence of FirstIcon
	const inputClasses = `
  border text-gray-400 text-xs rounded-lg block w-full
  ${FirstIcon ? "ps-10" : ""}
  p-2.5 bg-blue-gray bg-opacity-20 border-gray-600 placeholder-gray-400
  focus:ring-blue-gray focus:border-blue-gray 
  ${isDisabled ? "opacity-50 cursor-not-allowed bg-blue-gray " : ""}
`;

	return (
		<div className="flex flex-col">
			<label
				htmlFor={id}
				className={`mb-2 flex items-start justify-start font-normal text-gray-400 text-xs transition-opacity duration-200 ${
					isDisabled ? "cursor-not-allowed opacity-50" : "opacity-100"
				}`}
			>
				{label}
			</label>
			<div className="relative">
				{FirstIcon && (
					<div className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3.5">
						<FirstIcon className={`${iconbaseClasses}`} aria-hidden="true" />
					</div>
				)}
				<input
					type={type}
					id={id}
					value={value}
					onChange={(e) => onChange(e.target.value)}
					className={`${inputClasses} ${className}`}
					placeholder={placeholder}
					disabled={isDisabled}
					maxLength={maxLength}
					min={min}
					max={max}
					autoComplete={autoComplete}
				/>
				{!isDisabled && (
					<div
						className="absolute inset-y-0 end-0 flex cursor-pointer items-center pe-3.5"
						onClick={() => onClear(id)}
					>
						<svg
							className="h-4 w-4 text-gray-400"
							aria-hidden="true"
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							fill="none"
							viewBox="0 0 24 24"
						>
							<path
								stroke="currentColor"
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								d="M6 18 17.94 6M18 18 6.06 6"
							/>
						</svg>
					</div>
				)}
			</div>
			{info && (
				<span className={`custom-span mt-1 flex text-left font-normal text-sm ${infoColor}`}>
					{info}
				</span>
			)}
		</div>
	);
};

export default Input;
